import React from "react";
import FormattedData from "./FormattedData";
import IconWeather from "./IconWeather";
import CalcTemperature from "./CalcTemperature";

export default function InfoWeather(props) {
  return (
    <div className="infoWeather mt-4 mb-4">
      <h2>{props.weather.city}</h2>
      <p>
        <FormattedData data={props.weather.data} />
        {props.weather.description}
      </p>
      <div className="row">
        <div className="col-2">
          <IconWeather icon={props.weather.icon} size={64} />
        </div>
        <div className="col-5">
          <CalcTemperature temp={props.weather.temp} unit={"metric"} />
        </div>
        <div className="col-4">
          <ul>
            <li>Humidity: {props.weather.humidity}%</li>
            <li>Wind: {props.weather.wind}km/h</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
